import { useDashboardStyles } from "./styles";

type DashboardLinkProps = {
    title: string;
    subtitle: string;
    href: string;
    isDisplayed?: boolean;
};

const DashboardLink = (props: DashboardLinkProps) => {
    const { title, subtitle, href, isDisplayed } = props;
    const dashboardStyles = useDashboardStyles();
    
    return (
        <>
            {(isDisplayed || isDisplayed === undefined) && (
                <a className="mb-4 text-decoration-none" href={href}>
                    <div className="card-body">
                        <div className="d-flex flex-row justify-content-end">
                            <div className="col-11">
                                <h5 style={dashboardStyles.tileTitle} >{title}</h5>
                                <span style={dashboardStyles.titleSubtitle} className="mb-2">{subtitle}</span>
                            </div>
                            <div className="col pt-2 text-end">
                                    <span style={dashboardStyles.tileCaret} className="bi bi-caret-right-fill align-middle"></span>
                            </div>
                        </div>
                    </div>
                </a>
            )}
        </>
    );
};
DashboardLink.defaultProps = {
    handleClick: { undefined },
};
export type { DashboardLinkProps };
export default DashboardLink;
